import useModalStore from '@/stores/modal.store';

export interface ErrorModalProps {
  title: string;
  message: string;
}

export default function ErrorModal({ title, message }: ErrorModalProps) {
  const close = useModalStore((state) => state.close);

  return (
    <>
      <div className="mb-4 text-center">
        {/* Icon */}
        <div className="inline-flex my-4">
          <div className="w-14 h-14 rounded-full flex items-center justify-center shrink-0 bg-gray-100 dark:bg-gray-700">
            <svg className="shrink-0 fill-current text-red-500" width="24" height="24" viewBox="0 0 16 16">
              <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
            </svg>
          </div>
        </div>
        <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">{title}</div>
      </div>
      {/* Modal content */}
      <div className="text-center">
        <div className="text-sm mb-5">{message}</div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            close();
          }}
          className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
        >
          Jag förstår
        </button>
      </div>
    </>
  );
}
